import { render, staticRenderFns } from "./TenantParamsManager.vue?vue&type=template&id=263962f5&scoped=true&"
import script from "./TenantParamsManager.vue?vue&type=script&lang=js&"
export * from "./TenantParamsManager.vue?vue&type=script&lang=js&"
import style0 from "./TenantParamsManager.vue?vue&type=style&index=0&id=263962f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263962f5",
  null
  
)

export default component.exports